import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Role } from '~app/shared/enums/role.enum';
import { StoreService } from '~app/shared/services/store/store.service';

@Injectable({
  providedIn: 'root',
})
export class RoleRedirectorGuard {
  constructor(private readonly router: Router, private readonly store: StoreService) {}

  public canActivate(): boolean {
    const role = this.store.dashboard.selectedRole ? this.store.dashboard.selectedRole : this.store.currentUser.role;

    switch (role) {
      case Role.User:
        this.router.navigate(['/welcome']);
        break;
      case Role.CrewAdminManager:
      case Role.HRManager:
      case Role.HRTeam:
      case Role.Admin:
        this.router.navigate(['/dashboard/hr']);
        break;
      case Role.Safety:
        this.router.navigate(['/dashboard/safety']);
        break;
      case Role.Medical:
        this.router.navigate(['/dashboard/medical']);
        break;
      case Role.Finance:
        this.router.navigate(['/dashboard/finance']);
        break;
      default:
        throw new Error('You don’t have permissions for this action');
    }
    return false;
  }
}
